(window.MobileDropdown = function (Behaviors) {

  "use strict";
  
  function MobileDropdown(elem) {
    Behaviors.init(MobileDropdown, this, arguments);
    this.dropdown = this.$elem[0];
    this.items = this.dropdown.querySelectorAll('.navigation-mobile__list-item--has-dd');
    this.items.forEach(item => {
      item.addEventListener('click', (e)=>{
        //e.stopPropagation();
        //e.preventDefault();
        this.slideAnim(e);
      });
    })
  } 

  Behaviors.inherit(MobileDropdown, Behaviors.Behavior);
  MobileDropdown.QUERY = ".navigation-mobile";

  MobileDropdown.prototype.slideAnim = function(e) {
    this.el = e.currentTarget;
    this.body = this.el.querySelector('.navigation-mobile__dropdown');
    //console.log(this.body);
    this.active = document.querySelector('.navigation-mobile__list-item--active');
    if (this.active) {
      this.active.classList.remove('navigation-mobile__list-item--animate');
      this.active.querySelector('.navigation-mobile__dropdown').style.height = "0px";
      this.active.querySelector('.navigation-mobile__dropdown').addEventListener('transitionend', () => {
        this.active.classList.remove('navigation-mobile__list-item--active')
      }, { once: true })
    }
    if (!this.el.classList.contains('navigation-mobile__list-item--active')) {
      this.el.classList.add('navigation-mobile__list-item--active', 'navigation-mobile__list-item--animate')
      this.body.style.height = 'auto';
      this.height = this.body.offsetHeight + 'px';
      this.body.style.height = "0px";
      setTimeout(() => {
        this.body.style.height = this.height;
      }, 0);
    } else {
      this.el.classList.remove('navigation-mobile__list-item--animate');
      this.body.style.height = "0px";
      this.body.addEventListener('transitionend', () => {
        this.el.classList.remove('navigation-mobile__list-item--active');
      }, { once: true })
    }
  }

  Behaviors.register_behavior(MobileDropdown);

  return MobileDropdown;

  }(window.Behaviors));